.bar {
  position: absolute;
  right: 0;
  user-select: none;
  /* Sit above sibling content within the block's stacking context. The
   * surrounding `.block` has `isolation: isolate`, so this z-index is local
   * to the block — but several other in-block elements (gutter button,
   * resize handle, plugin children) also paint at z-index: 1. Without a
   * decisive bump, the marker is intermittently un-clickable depending on
   * which sibling happens to render on top of the right edge. */
  z-index: 2;
  display: flex;
  align-items: center;
  margin-right: 8px;
  /* Defensive: ensures clicks always reach the marker even when a transient
   * editor wrapper (e.g. selection range bar in performance mode) tries to
   * shadow the right edge with `pointer-events: none` plus opaque content. */
  pointer-events: auto;
}
